import { Plec } from '../enums/plec.enum';

export interface PeselData {
  pesel: string | null;
  isValid: boolean;
  isValidDateOfBirth: boolean;
  birthDate: Date | null;
  sex: Plec | null;
}

export class PeselUtils {
  static decode(pesel: string | null): PeselData {
    let isValid = false;
    let isValidDateOfBirth = false;
    let birthDate: Date | null = null;
    let sex: Plec | null = null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (pesel?.length !== 11) {
      return { pesel, isValid, isValidDateOfBirth, birthDate, sex };
    }

    const { rok, miesiac, dzien, valid } = this.pobierzDateUrodzenia(pesel);

    if (!valid) {
      return { pesel, isValid, isValidDateOfBirth, birthDate, sex };
    }

    if (
      miesiac < 1 ||
      miesiac > 12 ||
      this.ileDniWMiesiacu(rok, miesiac) < dzien
    ) {
      return { pesel, isValid, isValidDateOfBirth, birthDate, sex };
    }

    if (dzien < 1 || dzien > 31) {
      return { pesel, isValid, isValidDateOfBirth, birthDate, sex };
    }

    const dataUrodzenia = new Date(rok, miesiac - 1, dzien);
    dataUrodzenia.setHours(1, 0, 0, 0);

    if (dataUrodzenia > today) {
      return { pesel, isValid, isValidDateOfBirth, birthDate, sex };
    }

    isValidDateOfBirth = true;

    // Weryfikacja numeru PESEL
    const wagi = [9, 7, 3, 1, 9, 7, 3, 1, 9, 7];
    let suma = 0;

    for (let i = 0; i < wagi.length; i++) {
      suma += parseInt(pesel.substring(i, i + 1), 10) * wagi[i];
    }

    suma = suma % 10;

    const cyfraKontr = parseInt(pesel.substring(10, 11), 10);
    isValid = suma === cyfraKontr;

    // określenie płci
    sex =
      parseInt(pesel.substring(9, 10), 10) % 2 === 1
        ? Plec.MEZCZYZNA
        : Plec.KOBIETA;

    return {
      pesel,
      isValid,
      isValidDateOfBirth,
      birthDate: dataUrodzenia,
      sex,
    };
  }

  private static pobierzDateUrodzenia(pesel: string): {
    rok: number;
    miesiac: number;
    dzien: number;
    valid: boolean;
  } {
    let rok = parseInt(pesel.substring(0, 2), 10);
    let miesiac = parseInt(pesel.substring(2, 4), 10);
    const dzien = parseInt(pesel.substring(4, 6), 10);

    if ([0, 20, 40, 60, 80].includes(miesiac)) {
      return { rok, miesiac, dzien, valid: false };
    }

    if (miesiac >= 81 && miesiac <= 92) {
      rok += 1800;
      miesiac -= 80;
    } else if (miesiac >= 61 && miesiac <= 72) {
      rok += 2200;
      miesiac -= 60;
    } else if (miesiac >= 41 && miesiac <= 52) {
      rok += 2100;
      miesiac -= 40;
    } else if (miesiac >= 21 && miesiac <= 32) {
      rok += 2000;
      miesiac -= 20;
    } else {
      rok += 1900;
    }

    return { rok, miesiac, dzien, valid: true };
  }

  private static ileDniWMiesiacu(rok: number, miesiac: number): number {
    return new Date(rok, miesiac, 0).getDate();
  }
}
